<template>
  <div class="perm-wrap">
    <div class="permissions">
      <h2>{{ $t("perm.Permission") }}</h2>
      <div class="list-edit">
        <div class="list">
          <div
            class="single"
            v-for="(p, i) in currentPerm"
            :key="i"
            @click="selectPerm(p)"
            :class="{ selected: p.selected }"
          >
            <div>Permission Name:</div>
            <div>{{ p.per_name }}</div>
            <!-- <div class="delete" @click.stop.prevent="confirmDelete(p)">X </div> -->
          </div>
        </div>
        <div class="add" v-if="selPerm">
          <h3>{{ $t("perm.bindPerm") }}</h3>
          <div class="flex-s">
            <drop-down :selectedPermission='selPerm' @change="newPerm = $event"/>
            <button class="button-round" @click="createPerm">+</button>
          </div>
        </div>
      </div>
    </div>
    <div class="roles">
      <h2>{{ $t("perm.Role") }}</h2>
      <div class="list-edit">
        <div class="list">
          <div
            class="single"
            v-for="(r, i) in currentRoles"
            :key="i"
            @click="selectRole(r)"
            :class="{ selected: r.selected }"
          >
            <div>Role Name:</div>
            <div>{{ r.rol_name }}</div>
            <div class="delete" @click.stop.prevent="deleteRole(r)">X </div>
          </div>
        </div>
        <div class="edit-role roles-list" v-if="selRole">
          <div class="checkbox-wrap">
            <button class="button-round" @click="saveRolePermBind">Save</button>
            <button class="button-round" @click="selectRole(selRole)">
              Cancel
            </button>
          </div>
          <div v-for="(perm, i) in currentPerm" :key="i" class="checkbox-wrap">
            <input
              :id="`perm-${perm.per_id}`"
              type="checkbox"
              v-model="selRole.selectedPerms"
              :value="perm.per_id"
            />
            <label :for="`perm-${perm.per_id}`"> {{ perm.per_name }} </label>
          </div>
        </div>
        <div class="add" v-else>
          <h3>{{ $t("perm.newRole") }}</h3>
          <div class="flex-s">
            <input type="text" ref="role-name" />
            <button class="button-round" @click="createRole">+</button>
          </div>
        </div>
      </div>
    </div>
    <div class="users">
      <h2>{{ $t("perm.Users") }}</h2>
      <input
            type="text"
            placeholder="Search user:"
            v-model="searchUser"
            @keydown.enter="searchUserByText"
          />
      <!-- Single select -->
      <div class="list-edit">
        <div class="title">Single user edit</div>
        <div class="list">
          <div
            class="single"
            v-for="(u, i) in users"
            :key="i"
            @click="selectUser(u)"
            :class="{ selected: u.selected }"
          >
            <div>User Full Name: <span class="fullname">{{ u.usr_firstname + " " + u.usr_lastname }}</span></div>
          </div>
        </div>
        <div class="flex-s-t" v-if="selUser">
          <div class="roles roles-list">
            <h3>{{ $t("perm.Role") }}</h3>
            <div class="flex-s" v-for="(el, i) in currentRoles" :key="i">
              <input
                type="checkbox"
                
                @change="test(selUser, el)"
                :id="`r-list-${el.rol_id}`"
                v-model="selUser.selRoles"
                :value="el.rol_id"
              />
              <label :for="`r-list-${el.rol_id}`"> {{ el.rol_name }} </label>
            </div>
          </div>
          <div class="permissions permissions-list">
            <h3>{{ $t("perm.Permission") }}</h3>
            <div class="flex-s" v-for="(el, i) in currentPerm" :key="i">
              <input
                type="checkbox"
                :id="`p-list-${el.per_id}`"
                v-model="selUser.selPermissions"
                :value="el.per_id"
              />
              <label :for="`p-list-${el.per_id}`"> {{ el.per_name }} </label>
            </div>
          </div>
          <div class="flex-s">
            <button class="button-round" @click="saveUserBinds">Save</button>
            <button class="button-round" @click="selectUser(selUser)">
              Cancel
            </button>
          </div>
        </div>
      </div>

      <!-- Multi select -->
      <div class="list-edit">
        <div class="title">Group user edit</div>
        <div class="list">
          <div
            class="single"
            v-for="(u, i) in users"
            :key="i"
            @click="addGroupUser(u)"
            :class="{ selected: isInGroup(u) }"
          >
            <div>User Full Name: <span class="fullname">{{ u.usr_firstname + " " + u.usr_lastname }}</span></div>
          </div>
        </div>
        <div class="flex-s-t" v-if="groupUsers.length">
          <div class="roles roles-list">
            <h3>{{ $t("perm.Role") }}</h3>
            <div class="flex-s" v-for="(el, i) in currentRoles" :key="i">
              <input
                type="checkbox"
                :id="`r-list-2-${el.rol_id}`"
                v-model="groupRole"
                :value="el.rol_id"
              />
              <label :for="`r-list-2-${el.rol_id}`"> {{ el.rol_name }} </label>
            </div>
          </div>
          <div class="permissions permissions-list">
            <h3>{{ $t("perm.Permission") }}</h3>
            <div class="flex-s" v-for="(el, i) in currentPerm" :key="i">
              <input
                type="checkbox"
                :id="`p-list-2-${el.per_id}`"
                v-model="groupPerm"
                :value="el.per_id"
              />
              <label :for="`p-list-2-${el.per_id}`"> {{ el.per_name }} </label>
            </div>
          </div>
          <div class="flex-s">
            <button class="button-round" @click="saveGroupUserBinds">
              Save
            </button>
            <button class="button-round" @click="cancelGroup">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import DropDown from '@/components/admin/permisssions/dropdown.vue';
export default {
  components: { DropDown },
  data() {
    return {
      currentPerm: [],
      selPerm: null,
      currentRoles: [],
      selRole: null,
      users: [],
      selUser: null,
      groupUsers: [],
      groupPerm: [],
      groupRole: [],
      newPerm: "",
      newRole: "",
      searchUser: "",
    };
  },
  methods: {
    test (d,d2) {
      console.log(d.selRoles);
      console.log(d2);
    },
    async init() {
      try {
        let res = await api.getPermissions();
        let rol = await api.getRoles();
        let usr = await api.getUsers({
          limit: 10000,
          offset: 0,
        });
        this.addUsersFromApi(usr)
        rol.data.res.map((el) => {
          el.selectedPerms = el.rol_permissions
            .map((e) => e.per_id)
            .filter((e) => e);
          return el;
        });
        this.currentPerm = res.data.res;
        this.currentRoles = rol.data.res;
      } catch (error) {
        console.warn(error);
      }
    },
    addUsersFromApi(usr) {
      this.users = usr.data.result.map((el) => {
        el.roles = el.roles.map((e) => e.rol_id);
        el.permissions = el.permissions.map((e) => e.per_id);
        el.selRoles = [...el.roles];
        el.selPermissions = [...el.permissions];
        return el;
      });
    },
    isInGroup(u) {
      for (let i = 0; i < this.groupUsers.length; i++) {
        const user = this.groupUsers[i];
        if (user.usr_id === u.usr_id) return true;
      }
      return false;
    },
    addGroupUser(u) {
      this.$set(u, "gSelected", !u.gSelected);
      let alreadyIn = -1;

      for (let i = 0; i < this.groupUsers.length; i++) {
        const user = this.groupUsers[i];
        if (user.usr_id === u.usr_id) alreadyIn = i;
      }
      if (alreadyIn !== -1) this.groupUsers.splice(alreadyIn, 1);
      else this.groupUsers.push(JSON.parse(JSON.stringify(u)));
      console.log(this.groupUsers);
    },
    async saveGroupUserBinds() {
      let data = {
        rol_id: this.groupRole,
        per_id: this.groupPerm,
        usr_id: this.groupUsers.map((el) => el.usr_id),
      };
      try {
        let r1 = await api.bindPermToUser(data);
        let r2 = await api.bindRoleToUser(data);
        console.log(data);
        console.log(r1.data);
        console.log(r2.data);
        this.cancelGroup();
        this.init();
      } catch (error) {
        console.warn(error);
      }
    },
    cancelGroup() {
      if (this.users)
        for (const rs of this.users) {
          this.$set(rs, "gSelected", false);
        }
      this.groupUsers = [];
      this.groupPerm = [];
      this.groupRole = [];
    },
    async searchUserByText() {
      this.unsetUser();
      try {
        let usr = await api.getUsers({
          limit: 10000,
          offset: 0,
          search: this.searchUser,
        });
        this.addUsersFromApi(usr)
        // this.users = usr.data.result;
      } catch (error) {
        console.warn(error);
      }
      this.searchUser = "";
    },
    deleteRole (r) {
      this.EventBus.$emit('confirm', {
        okCallback: () => {this.confirmDelete(r)}
      })
    },
    async confirmDelete (item) {
      console.log(item);

      try {
        if (item.rol_id) {
          let res = await api.deleteRole(item.rol_id)
          console.log(res.data);
        }
        if (item.per_id) {
          // let res = await api.deletePermission(item.per_id)
          // console.log(res.data);
        }
        this.init()
      } catch (error) {
        console.warn(error);
      }
    },
    selectPerm(p) {
      for (const ps of this.currentPerm) {
        if (ps.per_id != p.per_id) {
          this.$set(ps, "selected", false);
        }
      }
      this.$set(p, "selected", !p.selected);
      if (!p.selected) this.selPerm = null;
      else this.selPerm = p;
    },
    selectRole(r) {
      for (const rs of this.currentRoles) {
        if (rs.rol_id != r.rol_id) {
          this.$set(rs, "selected", false);
          this.unsetRole();
        }
      }
      this.$set(r, "selected", !r.selected);
      if (!r.selected) this.unsetRole();
      else this.selRole = r;
    },
    selectUser(u) {
      for (const rs of this.users) {
        if (rs.usr_id != u.usr_id) {
          this.$set(rs, "selected", false);
          this.unsetUser();
        }
      }
      this.$set(u, "selected", !u.selected);
      console.log(u);
      if (!u.selected) this.unsetUser();
      else this.selUser = u;
    },
    unsetUser() {
      if (!this.selUser) return;
      this.selUser.selRoles = [...this.selUser.roles];
      this.selUser.selPermissions = [...this.selUser.permissions];
      this.selUser = null;
    },
    unsetRole() {
      if (!this.selRole) return;
      this.selRole.selectedPerms = this.selRole.rol_permissions
        .map((e) => e.per_id)
        .filter((e) => e);
      this.selRole = null;
    },
    unselectPerm() {
      for (const ps of this.currentPerm) {
        this.$set(ps, "selected", false);
      }
      this.selPerm = null;
    },
    unselectRole() {
      for (const rs of this.currentRoles) {
        this.$set(rs, "selected", false);
      }
      this.unsetRole();
    },
    async createPerm() {
      let ev_name = this.newPerm;
      if (ev_name == '') return;
      let data = {
        name: ev_name,
        parent_id: this.selPerm.per_id,
      };
      try {
        let res = await api.createSubPermission(data);
        console.log(res.data);
        this.init();
      } catch (error) {
        console.warn(error);
      }
      console.log(data);
      this.unselectPerm();
    },
    async createRole() {
      let rol_name = this.$refs["role-name"].value;
      if (rol_name == '') return;
      this.$refs["role-name"].value = "";
      let data = {
        rol_name,
      };
      try {
        let res = await api.createRole(data);
        console.log(res.data);
        await this.init();
      } catch (error) {
        console.warn(error);
      }
    },
    async saveRolePermBind() {
      try {
        let data = {
          rol_id: this.selRole.rol_id,
          per_ids: this.selRole.selectedPerms,
        };
        let res = await api.bindPermToRole(data);
        console.log(res.data);
        await this.init();
        this.selectRole(this.selRole);
      } catch (error) {
        console.warn(error);
      }
    },
    async saveUserBinds() {
      try {
        let data = {
          usr_id: this.selUser.usr_id,
          rol_id: this.selUser.selRoles,
          per_id: this.selUser.selPermissions,
        };
        let r1 = await api.bindPermToUser(data);
        let r2 = await api.bindRoleToUser(data);
        console.log(data);
        console.log(r1.data);
        console.log(r2.data);
        this.selectUser(this.selUser);
        this.init();
      } catch (error) {
        console.warn(error);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang='scss'>
.perm-wrap {
  overflow-y: auto;
  padding: 0 20px;
  width: 100%;
  min-height: calc(100vh - var(--nav-height));
  .flex-s {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .list-edit {
    margin: 30px 0;
    width: auto;
    position: relative;
    border: 2px solid black;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .fullname {
      font-weight: bold;
    }
    .title {
      position: absolute;
      left: 0;
      top: -25px;
      font-weight: 900;
    }
    .list {
      margin-right: 20px;
      max-height: 500px;
      overflow-y: auto;
      min-width: 500px;
      input {
        margin: 10px;
        width: calc(100% - 20px);
      }
      .single {
        margin: 10px;
        padding: 5px;
        position: relative;
        min-width: 180px;
        &.selected {
          border: 1px solid rgb(78, 137, 204);
        }
        .delete {
          user-select: none;
          cursor: pointer;
          position: absolute;
          right: 5px;
          top: 50%;
          transform: translateY(-50%);
          font-weight: 900;
        }
      }
    }
  }
  .permissions-list, .roles-list {
    padding: 10px 0;
    max-height: 500px;
    overflow-y: auto;
  }
  .edit-role {
    .checkbox-wrap {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .flex-s-t {
    margin-left: 20px;
    display: flex;
    .roles,
    .permissions {
      margin: 0 10px;
    }
  }
}
.button-round {
  margin: 10px;
  min-width: 40px;
}
</style>